module.exports = __webpack_public_path__ + "img/employees.6419284.jpg";